import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { venueUpdateChatMessageApi } from '../../../api/chat/venueUpdateChatMessageApi';

type Props = {
  onSuccess?: () => void;
};

export const useVenueUpdateChatMessageMutation = ({ onSuccess }: Props) => {
  const client = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation({
    mutationFn: venueUpdateChatMessageApi,
    onSettled: () => {
      enqueueSnackbar('Message updated successfully', { variant: 'success' });
      client.invalidateQueries({ queryKey: ['chat-list-venue-user'] });
      if (onSuccess) onSuccess();
    },
    onError: () => {
      enqueueSnackbar('Something went wrong while updating the message', { variant: 'error' });
    },
  });

  return mutation;
};
